function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  stroke: "#616161",
  strokeWidth: 2,
  strokeDasharray: "3.3 3.3",
  d: "M13 42V24h40v18z"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M43.27 45.1l-.187-25a2.502 2.502 0 00-2.519-2.48l-15 .112a2.502 2.502 0 00-2.481 2.519l.187 24.999c.005.689.29 1.31.747 1.76.456.45 1.084.724 1.771.72l15.001-.112a2.502 2.502 0 002.48-2.518zM25.582 20.232l15.001-.113.019 2.5-15.001.112-.019-2.5zm.15 20L25.62 25.23l15-.112.113 15-15 .113zm.038 4.999l-.02-2.5 15.002-.112.018 2.5-15 .112z",
  fill: "#616161"
});

function SvgRotate(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 66,
    fill: "none"
  }, props), _ref, _ref2);
}

export default SvgRotate;